(() => {
  const MOBILE = '(max-width: 749px)';
  const set = (el, prop, value) => el?.style.setProperty(prop, value, 'important');
  const text = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim();

  const common = (a, b, boundary) => {
    let node = a;
    while (node && node !== boundary?.parentElement) {
      if (node.contains(b)) return node;
      node = node.parentElement;
    }
    return null;
  };

  const centerChain = (start, stop) => {
    let node = start;
    while (node && node !== stop?.parentElement) {
      set(node, 'position', 'relative');
      set(node, 'left', 'auto');
      set(node, 'right', 'auto');
      set(node, 'top', 'auto');
      set(node, 'bottom', 'auto');
      set(node, 'float', 'none');
      set(node, 'width', '100%');
      set(node, 'max-width', 'none');
      set(node, 'margin-left', 'auto');
      set(node, 'margin-right', 'auto');
      set(node, 'transform', 'none');
      set(node, 'text-align', 'center');
      set(node, 'overflow', 'visible');
      if (node === stop) break;
      node = node.parentElement;
    }
  };

  const apply = () => {
    if (!window.matchMedia(MOBILE).matches) return;

    const footer = document.querySelector('footer');
    if (!footer) return;

    const collabHeading = [...footer.querySelectorAll('h1,h2,h3,h4,h5,h6,p')]
      .find((el) => /^Colaboraciones\s*&\s*Canjes$/i.test(text(el)));

    const regret = [...footer.querySelectorAll('a,button,[role="button"]')]
      .find((el) => /BOT[ÓO]N DE ARREPENTIMIENTO/i.test(text(el)))
      || [...footer.querySelectorAll('p,span,div')]
        .find((el) => /BOT[ÓO]N DE ARREPENTIMIENTO/i.test(text(el)) && el.children.length <= 2);

    if (!collabHeading || !regret) return;

    const section = collabHeading.closest('.shopify-section')
      || regret.closest('.shopify-section')
      || footer;
    const root = common(collabHeading, regret, section) || section;

    set(section, 'overflow', 'visible');
    set(section, 'text-align', 'center');

    set(root, 'position', 'relative');
    set(root, 'left', 'auto');
    set(root, 'right', 'auto');
    set(root, 'display', 'flex');
    set(root, 'flex-direction', 'column');
    set(root, 'align-items', 'center');
    set(root, 'justify-content', 'flex-start');
    set(root, 'gap', '0');
    set(root, 'width', '100%');
    set(root, 'max-width', 'none');
    set(root, 'margin', '0 auto');
    set(root, 'padding', '0');
    set(root, 'transform', 'none');
    set(root, 'overflow', 'visible');
    set(root, 'text-align', 'center');

    let regretPanel = regret.closest('.group-block');
    if (regretPanel?.contains(collabHeading)) regretPanel = null;
    regretPanel = regretPanel
      || regret.closest('[id*="__button_"]')
      || regret.closest('[id*="__custom_liquid_"]')
      || regret.parentElement;

    centerChain(regret.parentElement, regretPanel);

    set(regretPanel, 'display', 'flex');
    set(regretPanel, 'flex-direction', 'column');
    set(regretPanel, 'align-items', 'center');
    set(regretPanel, 'justify-content', 'center');
    set(regretPanel, 'align-self', 'stretch');
    set(regretPanel, 'box-sizing', 'border-box');
    set(regretPanel, 'width', '100%');
    set(regretPanel, 'max-width', 'none');
    set(regretPanel, 'min-height', '76px');
    set(regretPanel, 'margin', '0 auto');
    set(regretPanel, 'padding', '30px 16px 8px');
    set(regretPanel, 'transform', 'none');
    set(regretPanel, 'overflow', 'visible');
    set(regretPanel, 'text-align', 'center');

    set(regret, 'position', 'relative');
    set(regret, 'left', 'auto');
    set(regret, 'right', 'auto');
    set(regret, 'top', 'auto');
    set(regret, 'bottom', 'auto');
    set(regret, 'float', 'none');
    set(regret, 'display', 'inline-flex');
    set(regret, 'align-items', 'center');
    set(regret, 'justify-content', 'center');
    set(regret, 'width', 'auto');
    set(regret, 'max-width', 'calc(100% - 32px)');
    set(regret, 'min-width', '184px');
    set(regret, 'min-height', '38px');
    set(regret, 'margin', '0 auto');
    set(regret, 'padding', '9px 15px');
    set(regret, 'transform', 'none');
    set(regret, 'line-height', '1.15');
    set(regret, 'white-space', 'nowrap');
    set(regret, 'text-align', 'center');
    set(regret, 'overflow', 'visible');

    const paragraph = [...section.querySelectorAll('p')]
      .find((el) => /influencer|creador\/a de contenido|campañas o canjes/i.test(text(el)));
    const collabPanel = collabHeading.closest('.group-block')
      || common(collabHeading, paragraph, section)
      || collabHeading.parentElement;
    const headingBlock = collabHeading.closest('[id*="__text_"]') || collabHeading.parentElement;
    const paragraphBlock = paragraph?.closest('[id*="__text_"]') || paragraph?.parentElement;

    set(collabPanel, 'position', 'relative');
    set(collabPanel, 'left', 'auto');
    set(collabPanel, 'right', 'auto');
    set(collabPanel, 'display', 'flex');
    set(collabPanel, 'flex-direction', 'column');
    set(collabPanel, 'align-items', 'center');
    set(collabPanel, 'justify-content', 'center');
    set(collabPanel, 'align-self', 'stretch');
    set(collabPanel, 'gap', '10px');
    set(collabPanel, 'box-sizing', 'border-box');
    set(collabPanel, 'width', '100%');
    set(collabPanel, 'max-width', 'none');
    set(collabPanel, 'margin', '0 auto');
    set(collabPanel, 'padding', '16px 46px 92px');
    set(collabPanel, 'transform', 'translateX(-12px)');
    set(collabPanel, 'text-align', 'center');

    [headingBlock, paragraphBlock].forEach((block) => {
      if (!block) return;
      set(block, 'position', 'relative');
      set(block, 'left', 'auto');
      set(block, 'right', 'auto');
      set(block, 'display', 'flex');
      set(block, 'align-items', 'center');
      set(block, 'justify-content', 'center');
      set(block, 'align-self', 'center');
      set(block, 'width', '100%');
      set(block, 'max-width', block === headingBlock ? '255px' : '236px');
      set(block, 'margin', '0 auto');
      set(block, 'padding', '0');
      set(block, 'transform', block === headingBlock ? 'translateX(-6px)' : 'none');
      set(block, 'text-align', 'center');
    });

    set(collabHeading, 'margin', '0 auto');
    set(collabHeading, 'max-width', '255px');
    set(collabHeading, 'text-align', 'center');

    if (paragraph) {
      set(paragraph, 'margin', '0 auto');
      set(paragraph, 'max-width', '236px');
      set(paragraph, 'text-align', 'center');
    }
  };

  const start = () => {
    apply();
    [80, 250, 600, 1200, 2000].forEach((ms) => setTimeout(apply, ms));
    new MutationObserver(() => requestAnimationFrame(apply))
      .observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:select', apply);
    window.addEventListener('resize', apply);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
